<template>
    <a v-if="!provider" class="provider" :href="generateUrl()">
        <img
            :src="`images/providers/white/home.png`"
            class="img-fluid"
            alt="Home"
        />
    </a>

    <a v-else-if="provider.name === 'los-toestel'"
       href="/los-toestel"
       class="provider"
    >
        Los toestel
    </a>

    <a v-else :href="generateUrl()" class="provider">
        <img
            :src="`/images/providers/white/${this.$filters.lowerCase(provider.name)}.png`"
            :alt="provider.name"
            class="img-fluid"
        />
    </a>
</template>

<script>
import {SORT_TYPE, TYPE} from "../constants";

export default {
    props: {
        provider: {
            type: Object,
            default: null
        },

        selectedFilters: {
            type: Object,
            required: true
        },

        alternativeOffer: {
            type: Number,
            required: false
        }
    },

    methods: {
        generateUrl() {
            const type = this.selectedFilters.is_renewal ? TYPE.BUSINESS : TYPE.NEW;
            const sortType = this.selectedFilters.has_device ? SORT_TYPE.DEVICE : SORT_TYPE.SIM_ONLY;
            const brand = this.selectedFilters.brand ?? '';
            const model = this.selectedFilters.model ?? '';

            let preFilters = null;
            let providerUrl = '';

            if (this.selectedFilters.is_business) {
                providerUrl += '/zakelijk';
            }

            providerUrl += !this.provider ? '/' : `/${this.provider.name.toLowerCase()}/`;

            if (this.provider && this.provider.families) {
                preFilters = JSON.parse(this.provider.families.sort((a, b) => a.sort_order - b.sort_order)[0].pre_filter)

                preFilters = preFilters[type][sortType]
                preFilters = Object.keys(preFilters)
                    .filter((k) => preFilters[k] != null)
                    .reduce((a, k) => ({...a, [k]: preFilters[k]}), {})

                preFilters = new URLSearchParams(preFilters).toString()
            }

            if (!this.selectedFilters.has_device) {
                providerUrl += `${sortType}/`
            } else {
                if (brand) {
                    providerUrl += `${this.$filters.lowerCase(brand, '-')}/`
                }

                if (model) {
                    providerUrl += `${this.$filters.lowerCase(model, '-')}/`
                }
            }

            if (this.alternativeOffer) {
                providerUrl += this.alternativeOffer
            } else if (preFilters) {
                providerUrl += `?${preFilters}`
            }

            return providerUrl
        }
    }
}
</script>
